import React from "react";

import ThemeToggler from "./ThemeToggler";

const Header = () => {
  return (
    <header>
      <h1>Theme Toggler using Context Example Click below block for Action</h1>
      <ThemeToggler />
    </header>
  );
};

export default Header;
